import { baseApi } from "@/redux/api/baseApi";

const sameDayDelivery = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateSameDayAvailableCreator: builder.mutation({
      query: (payload) => ({
        url: `/same-day-delivery/update`,
        method: "POST",
        body: {
          availability: payload.availability,
          address_id: payload.address_id,
          delivery_scope: payload.delivery_scope,
        },
      }),
      invalidatesTags: ["sameDayDelivery"],
    }),

    // Mutation to get availability by creatorId (optional in this case)
    getAvailabilityByCreatorId: builder.query({
      query: () => ({
        url: `/same-day-delivery/get`,
        method: "GET",
      }),
      providesTags: ["sameDayDelivery"],
    }),

    uploadSameDayDeliveryData: builder.mutation({
      query: (body) => ({
        url: `/same-day-delivery/create`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["sameDayDelivery"],
    }),
  }),
});

export const {
  useGetAvailabilityByCreatorIdQuery,
  useUpdateSameDayAvailableCreatorMutation,
  useUploadSameDayDeliveryDataMutation,
} = sameDayDelivery;
